<template>
  <div class="row reverse-mobile justify-content-center">
    <AdminMenu />

    <div class="col-12 col-md-9 center-content">
      <CommunityCard>
        <div class="row">
          <PleaseWait
            v-if="is_loading_users"
            bg-colour="#ffffff"
            class="m-4 w-100 d-flex flex-column justify-content-center align-items-center small-full"
          />
          <BarChart
            v-else
            class="m-4"
            :data="chartDataUsers"
            :options="chartOptions"
          />

          <PleaseWait
            v-if="is_loading_groups"
            bg-colour="#ffffff"
            class="m-4 w-100 d-flex flex-column justify-content-center align-items-center small-full"
          />
          <BarChart
            v-else
            class="m-4"
            :data="chartDataGroups"
            :options="chartOptions"
          />

          <PleaseWait
            v-if="is_loading_posts"
            bg-colour="#ffffff"
            class="m-4 w-100 d-flex flex-column justify-content-center align-items-center small-full"
          />
          <BarChart
            v-else
            class="m-4"
            :data="chartDataPosts"
            :options="chartOptions"
          />
        </div>
      </CommunityCard>
    </div>
  </div>
</template>

<script>
import AdminMenu from "@/components/AdminMenu";
import PleaseWait from "@/components/PleaseWait";
import BarChart from "@/components/BarChart";
import UserService from "@/services/user.service";
import CommunityCard from "@/components/CommunityCard";

export default {
  name: "Analytics",
  components: {
    CommunityCard,
    AdminMenu,
    PleaseWait,
    BarChart,
  },
  data: function () {
    return {
      is_loading_users: true,
      is_loading_groups: true,
      is_loading_posts: true,
      chartDataUsers: null,
      chartDataGroups: null,
      chartDataPosts: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  if (Number.isInteger(value)) {
                    return value;
                  }
                },
                stepSize: 1,
              },
            },
          ],
        },
      },
    };
  },
  methods: {
    getAnalyticsUsers() {
      UserService.getAnalyticsUsers()
        .then((data) => {
          this.chartDataUsers = {
            labels: data.monthLabels,
            datasets: [
              {
                label: "Active Users",
                backgroundColor: "#7979f877",
                data: data.activeUsers,
              },
              {
                label: "New Users",
                backgroundColor: "#79f87977",
                data: data.newUsers,
              },
            ],
          };
          this.is_loading_users = false;
        })
        .catch((error) => {
          if (error.message.includes("404")) {
            this.component404 = true;
          }
        });

      UserService.getAnalyticsGroups()
        .then((data) => {
          this.chartDataGroups = {
            labels: data.monthLabels,
            datasets: [
              {
                label: "Active Groups",
                backgroundColor: "#7979f877",
                data: data.activeGroups,
              },
              {
                label: "New Groups",
                backgroundColor: "#79f87977",
                data: data.newGroups,
              },
            ],
          };
          this.is_loading_groups = false;
        })
        .catch((error) => {
          if (error.message.includes("404")) {
            this.component404 = true;
          }
        });

      UserService.getAnalyticsPosts()
        .then((data) => {
          this.chartDataPosts = {
            labels: data.monthLabels,
            datasets: [
              {
                label: "Posts",
                backgroundColor: "#79f87977",
                data: data.newPosts,
              },
            ],
          };
          this.is_loading_posts = false;
        })
        .catch((error) => {
          if (error.message.includes("404")) {
            this.component404 = true;
          }
        });
    },
  },
  mounted() {
    this.is_loading_users = true;
    this.is_loading_groups = true;
    this.is_loading_posts = true;
    this.getAnalyticsUsers();
  },
};
</script>

<style>
.chart {
  padding: 24px;
}
</style>
